// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// NGRX
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
// Translate
import { TranslateModule } from '@ngx-translate/core';
import { PartialsModule } from '../../partials/partials.module';
// Services
import { HttpUtilsService, TypesUtilsService, InterceptService, LayoutUtilsService} from '../../../core/_base/crud';
// Shared
import { ActionNotificationComponent } from '../../partials/content/crud';
// Components
import { BlockgroupComponent } from './blockgroup.component';
import { ListBlockGroupComponent } from './list-block-group/list-block-group.component';
import { EditBlockGroupComponent } from './edit-block-group/edit-block-group.component';
import { AddBlockGroupComponent } from './add-block-group/add-block-group.component';
import { EditStructureListDialogComponent } from './edit-structure-list/edit-structure-list.dialog.component';

// Material
import {
	MatInputModule,
	MatPaginatorModule,
	MatProgressSpinnerModule,
	MatSortModule,
	MatTableModule,
	MatSelectModule,
	MatMenuModule,
	MatProgressBarModule,
	MatButtonModule,
	MatCheckboxModule,
	MatDialogModule,
	MatTabsModule,
	MatNativeDateModule,
	MatCardModule,
	MatRadioModule,
	MatIconModule,
	MatDatepickerModule,
	MatExpansionModule,
	MatAutocompleteModule,
	MAT_DIALOG_DEFAULT_OPTIONS,
	MatSnackBarModule,
	MatTooltipModule,
} from '@angular/material';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import {
	blockGroupReducer
} from '../../../core/blockgroup/blockgroup.reducer';
import { BlockGroupEffect } from '../../../core/blockgroup/blockgroup.effect';

const routes: Routes = [
	{
		path: '',
		component: BlockgroupComponent,
		children: [
			{
				path: '',
				component: AddBlockGroupComponent
			},
			{
				path: 'add',
				component: AddBlockGroupComponent
			},
			{
				path: 'edit/:id',
				component: EditBlockGroupComponent
			},
			{
				path: 'list',
				component: ListBlockGroupComponent
			}
		]
	}
];

@NgModule({
	imports: [
		CommonModule,
		HttpClientModule,
		PartialsModule,
		RouterModule.forChild(routes),
		StoreModule.forFeature('blockgroup', blockGroupReducer),
		EffectsModule.forFeature([BlockGroupEffect]),
		FormsModule,
		ReactiveFormsModule,
		TranslateModule.forChild(),
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
		MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatExpansionModule,
		MatTabsModule,
		MatTooltipModule,
		MatDialogModule,
		NgbModule
	],
	providers: [
		InterceptService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: InterceptService,
			multi: true
		},
		{
			provide: MAT_DIALOG_DEFAULT_OPTIONS,
			useValue: {
				hasBackdrop: true,
				panelClass: 'kt-mat-dialog-container__wrapper',
				height: 'auto',
				width: '900px'
			}
		},
		HttpUtilsService,
		TypesUtilsService,
		LayoutUtilsService
	],
	entryComponents: [
		ActionNotificationComponent,
		BlockgroupComponent,
		EditStructureListDialogComponent
	],
	declarations: [
		BlockgroupComponent,
		ListBlockGroupComponent,
		EditBlockGroupComponent,
		AddBlockGroupComponent,
		EditStructureListDialogComponent
	]
})
export class BlockGroupModule {}
